import React from 'react';
import { Outlet } from 'react-router-dom';
import { Toolbar } from '@mui/material';

import { Box, Flex } from '../../Components/Base';
import { AppBar, MENU_DRAWER_WIDTH, APP_BAR_HEIGHT } from '../../Components/Layout';
import HamburgerMenu from '../HamburgerMenu';
import UserButton from '../UserButton';
import SideBar from '../SideBar';

import ExaminationManagement from './ExaminationManagement';
import EnsureLeavingListener from './EnsureLeavingListener';
import Header from './Header';
import ExaminationPreloader from './ExaminationPreloader';

const ExaminationLayout = ({ children }: { children?: React.ReactChild }) => {
  return (
    <ExaminationPreloader>
      <AppBar>
        <HamburgerMenu />
        <Flex width={1} justifyContent={'space-between'}>
          <Header />
          <Box flex="0 0 auto">
            <UserButton />
          </Box>
          {/* TODO: Info icon */}
        </Flex>
      </AppBar>
      <SideBar />
      <Toolbar />
      <Flex bgcolor={'grey.50'}>
        <Box width={`${MENU_DRAWER_WIDTH}px`} display={{ xs: 'none', md: 'block' }} />
        <Flex
          flexDirection={'column'}
          component="main"
          p={3}
          minHeight={`calc(100vh - ${APP_BAR_HEIGHT}px)`}
          width={{ md: `calc(100% - ${MENU_DRAWER_WIDTH}px)` }}
          maxWidth={1440}
          m={'auto'}
          sx={{ flexGrow: 1 }}
        >
          <ExaminationManagement />
          <Box mt={2} />
          {children ?? <Outlet />}
        </Flex>
      </Flex>
      <EnsureLeavingListener />
    </ExaminationPreloader>
  );
};

export default ExaminationLayout;
